/* FRAME Universal — motion respects accessibility preferences. */
(()=>{
  'use strict';
  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion && document.documentElement && 'IntersectionObserver' in window) {
    const targets=[...document.querySelectorAll('[data-reveal]')];
    if(targets.length){
      const io=new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
          if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target);}
        });
      },{rootMargin:'0px 0px -45px 0px',threshold:0.06});
      targets.forEach((target)=>io.observe(target));
      document.body.classList.add('motion-ready');
    }
  }
  document.addEventListener('shopify:section:load',(event)=>{
    event.target.querySelectorAll('[data-reveal]').forEach((el)=>el.classList.add('is-visible'));
  });
  document.addEventListener('change',(event)=>{
    const select=event.target.closest('[data-variant-select]');
    if(!select)return;
    const panel=select.closest('.product-info');
    if(!panel)return;
    const selected=select.options[select.selectedIndex];
    const display=panel.querySelector('[data-variant-price]');
    if(display && selected.dataset.price)display.textContent=selected.dataset.price;
    const button=panel.querySelector('[data-add-button]');
    const label=panel.querySelector('[data-add-label]');
    const available=selected.dataset.available==='true';
    if(button)button.disabled=!available;
    if(label)label.textContent=available?'Add to cart':'Sold out';
  });
  document.addEventListener('click',(event)=>{
    const thumb=event.target.closest('[data-gallery-image]');
    if(!thumb)return;
    const gallery=thumb.closest('.product-gallery');
    const main=gallery?.querySelector('.product-gallery__primary img');
    if(main){main.src=thumb.dataset.galleryImage;main.removeAttribute('srcset');main.alt=thumb.dataset.galleryAlt||'';}
  });
  const mobileNav=document.querySelector('.mobile-nav');
  if(mobileNav){
    const summary=mobileNav.querySelector('summary');
    const syncLabel=()=>summary.setAttribute('aria-label',mobileNav.open?'Close menu':'Open menu');
    mobileNav.addEventListener('toggle',syncLabel);syncLabel();
    document.addEventListener('keydown',(event)=>{if(event.key==='Escape'&&mobileNav.open){mobileNav.open=false;summary.focus();}});
    document.addEventListener('click',(event)=>{if(mobileNav.open&&!mobileNav.contains(event.target))mobileNav.open=false;});
    mobileNav.querySelectorAll('nav a').forEach((link)=>link.addEventListener('click',()=>{mobileNav.open=false;}));
  }
  if(location.hash==='#NewsletterForm'){
    const message=document.querySelector('#NewsletterForm [role="status"],#NewsletterForm [role="alert"]');
    if(message){message.setAttribute('tabindex','-1');message.focus();}
  }
})();
